var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.99207 21.07594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.926,7.12593a.51786.51786,0,0,1-.46.27.59052.59052,0,0,1-.25-.07l-9.22-5.12-9.22,5.12a.52358.52358,0,0,1-.71-.2.5328.5328,0,0,1,.2-.72L9.736,1.146a.53437.53437,0,0,1,.52,0l4.66,2.59V.526a.52465.52465,0,0,1,.84-.42l2.11,1.58a.52506.52506,0,0,1-.63.84l-1.27-.95v2.74l3.76,2.09A.5328.5328,0,0,1,19.926,7.12593Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.94605,9.89595v8.55a2.63322,2.63322,0,0,1-2.63,2.63h-3.69a.525.525,0,0,1-.52-.53v-9.15h-4.22v9.15a.525.525,0,0,1-.52.53H3.676a2.63321,2.63321,0,0,1-2.63-2.63v-8.55a.53.53,0,1,1,1.06,0v8.55a1.57485,1.57485,0,0,0,1.57,1.58h3.16v-9.16a.53348.53348,0,0,1,.53-.53h5.26a.53348.53348,0,0,1,.53.53v9.16h3.16a1.57485,1.57485,0,0,0,1.57-1.58v-8.24l-2.35-1.3a.52356.52356,0,1,1,.5-.92l2.63,1.45A.52714.52714,0,0,1,18.94605,9.89595Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeOut);
export default __webpack_public_path__ + "static/media/iconHomeOut.b61021c11dd84950a30de23640a331de.svg";
export { ForwardRef as ReactComponent };